import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './OrderCreditApprove.style';
import LoadingImage from 'assets/svg/loading.svg';
import { H5, P } from 'utils/resuable-css';
import { useTranslation } from 'react-i18next';

const OrderCreditApprove = () => {
  const { t } = useTranslation();
  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="shopping cart" color="black" />
              <H5>{t('dashboard.string20')}</H5>
              {false && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
            <Styles.Right>
              <Icon name="expand" />
            </Styles.Right>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          <P style={{ padding: '1em 0' }}>{t('dashboard.string21')}</P>
        </Styles.Content>
      </div>
    </Styles.DraggableContainer>
  );
};
export default OrderCreditApprove;
